<section class="profil-bearbeiten">
  <header class="profil-bearbeiten__header">
    <div class="profil-bearbeiten__header-inner">
      <div class="profil-bearbeiten__header-left">
        <button
          type="button"
          class="profil-bearbeiten__back"
          data-testid="profil-zurueck"
          [attr.aria-label]="'profilBearbeiten.zurueck' | translate"
          (click)="zumKonto()"
        >
          <mat-icon aria-hidden="true">chevron_left</mat-icon>
        </button>
        <div class="profil-bearbeiten__header-text">
          <div class="profil-bearbeiten__eyebrow">{{ 'profilBearbeiten.eyebrow' | translate }}</div>
          <h1 class="profil-bearbeiten__title">{{ 'profilBearbeiten.titel' | translate }}</h1>
        </div>
        @if (hasUnsavedChanges()) {
          <span class="profil-bearbeiten__pill" data-testid="profil-pill" role="status">
            <span class="profil-bearbeiten__pill-punkt" aria-hidden="true"></span>
            {{ 'profilBearbeiten.ungespeichert' | translate }}
          </span>
        }
      </div>
      <div class="profil-bearbeiten__header-actions">
        <button type="button" class="profil-bearbeiten__cancel" data-testid="profil-abbrechen" (click)="zumKonto()">
          {{ 'profilBearbeiten.abbrechen' | translate }}
        </button>
        <button
          type="button"
          class="profil-bearbeiten__save"
          data-testid="profil-speichern"
          [disabled]="!kannSpeichern()"
          (click)="speichern()"
        >
          <mat-icon aria-hidden="true">check</mat-icon>
          <span>{{ 'profilBearbeiten.speichern' | translate }}</span>
        </button>
      </div>
    </div>
  </header>

  <div class="profil-bearbeiten__body">
    @if (ladefehler()) {
      <div class="profil-bearbeiten__ladefehler" data-testid="profil-ladefehler" role="alert">
        <p class="profil-bearbeiten__ladefehler-text">{{ 'profilBearbeiten.ladefehler' | translate }}</p>
        <button type="button" mat-stroked-button data-testid="profil-erneut" (click)="laden()">
          {{ 'common.retry' | translate }}
        </button>
      </div>
    } @else {
      <article class="profil-bearbeiten__karte profil-bearbeiten__bild">
        <div
          class="profil-bearbeiten__dropzone"
          data-testid="profilbild-dropzone"
          [class.profil-bearbeiten__dropzone--zieht]="zieht()"
          [attr.aria-busy]="verarbeitet() || null"
          (dragenter)="ziehenBeginnt($event)"
          (dragover)="ziehenUeber($event)"
          (dragleave)="ziehenEndet($event)"
          (drop)="loslassen($event)"
        >
          <button
            type="button"
            class="profil-bearbeiten__avatar-knopf"
            data-testid="profilbild-avatar"
            [attr.aria-label]="'profilBearbeiten.profilbild.aendern' | translate"
            [title]="'profilBearbeiten.profilbild.aendern' | translate"
            [disabled]="bildGesperrt()"
            (click)="dateiInput.click()"
          >
            <app-avatar [name]="profil()?.displayName ?? ''" [size]="90" [src]="vorschau()" />
            <span class="profil-bearbeiten__avatar-overlay" aria-hidden="true">
              <mat-icon>image</mat-icon>
              <span>{{ 'profilBearbeiten.profilbild.overlay' | translate }}</span>
            </span>
          </button>
          <div class="profil-bearbeiten__bild-text">
            <div class="profil-bearbeiten__bild-titel">{{ 'profilBearbeiten.profilbild.titel' | translate }}</div>
            <div class="profil-bearbeiten__bild-hinweis" data-testid="profilbild-hinweis" role="status">
              @if (zieht()) {
                {{ 'profilBearbeiten.profilbild.ziehen' | translate }}
              } @else if (neueDatei(); as neu) {
                {{ 'profilBearbeiten.profilbild.neu' | translate }}
                <strong>{{ neu.dateiname }}</strong>
                {{ 'profilBearbeiten.profilbild.neuRest' | translate: { kb: neu.kb } }}
              } @else if (bildAenderung()?.art === 'entfernen') {
                {{ 'profilBearbeiten.profilbild.entfernt' | translate }}
              } @else {
                {{ 'profilBearbeiten.profilbild.standard' | translate }}
              }
            </div>
            @if (bestaetigung()) {
              <div class="profil-bearbeiten__bild-bestaetigung">
                <span class="profil-bearbeiten__bild-frage">{{ 'profilBearbeiten.profilbild.frage' | translate }}</span>
                <button
                  #abbrechenKnopf
                  type="button"
                  class="profil-bearbeiten__bild-knopf"
                  data-testid="profilbild-entfernen-abbrechen"
                  [disabled]="bildGesperrt()"
                  (click)="entfernenAbbrechen()"
                >
                  {{ 'profilBearbeiten.profilbild.abbrechen' | translate }}
                </button>
                <button
                  type="button"
                  class="profil-bearbeiten__bild-knopf profil-bearbeiten__bild-knopf--gefahr"
                  data-testid="profilbild-entfernen-bestaetigen"
                  [disabled]="bildGesperrt()"
                  (click)="entfernenBestaetigen()"
                >
                  <mat-icon aria-hidden="true">delete</mat-icon>
                  {{ 'profilBearbeiten.profilbild.jaEntfernen' | translate }}
                </button>
              </div>
            } @else {
              <div class="profil-bearbeiten__bild-aktionen">
                <button
                  #hochladenKnopf
                  type="button"
                  class="profil-bearbeiten__bild-knopf"
                  data-testid="profilbild-hochladen"
                  [disabled]="bildGesperrt()"
                  (click)="dateiInput.click()"
                >
                  <mat-icon aria-hidden="true">image</mat-icon>
                  {{
                    (hatBild() ? 'profilBearbeiten.profilbild.aendern' : 'profilBearbeiten.profilbild.hochladen')
                      | translate
                  }}
                </button>
                <span
                  class="profil-bearbeiten__bild-tooltip"
                  [matTooltip]="'profilBearbeiten.profilbild.keinBild' | translate"
                  [matTooltipDisabled]="hatBild()"
                >
                  <button
                    #entfernenKnopf
                    type="button"
                    class="profil-bearbeiten__bild-knopf profil-bearbeiten__bild-knopf--gefahr"
                    data-testid="profilbild-entfernen"
                    [disabled]="!hatBild() || bildGesperrt()"
                    [attr.aria-disabled]="hatBild() ? null : 'true'"
                    (click)="entfernenFragen()"
                  >
                    <mat-icon aria-hidden="true">delete</mat-icon>
                    {{ 'profilBearbeiten.profilbild.entfernen' | translate }}
                  </button>
                </span>
              </div>
            }
            @if (bildFehler(); as fehler) {
              <div class="profil-bearbeiten__bild-fehler" data-testid="profilbild-fehler" role="alert">
                <mat-icon aria-hidden="true">close</mat-icon>
                <span>{{ fehler.schluessel | translate: fehler.params }}</span>
              </div>
            }
          </div>
          <input
            #dateiInput
            type="file"
            accept="image/jpeg,image/png"
            hidden
            data-testid="profilbild-datei"
            (change)="dateiGewaehlt($event)"
          />
        </div>
      </article>

      <article class="profil-bearbeiten__karte" [formGroup]="form">
        <to-section-title
          [title]="'profilBearbeiten.stammdaten.titel' | translate"
          [subtitle]="'profilBearbeiten.stammdaten.untertitel' | translate"
        />
        <div class="profil-bearbeiten__raster">
          <mat-form-field appearance="fill" class="profil-bearbeiten__feld">
            <mat-label>{{ 'profilBearbeiten.stammdaten.vorname' | translate }}</mat-label>
            <input
              matInput
              formControlName="firstName"
              data-testid="profil-vorname"
              autocomplete="given-name"
              [attr.maxlength]="nameMax"
              required
            />
            <mat-error>{{ fehlerSchluessel(form.controls.firstName) | translate }}</mat-error>
          </mat-form-field>

          <mat-form-field appearance="fill" class="profil-bearbeiten__feld">
            <mat-label>{{ 'profilBearbeiten.stammdaten.nachname' | translate }}</mat-label>
            <input
              matInput
              formControlName="lastName"
              data-testid="profil-nachname"
              autocomplete="family-name"
              [attr.maxlength]="nameMax"
              required
            />
            <mat-error>{{ fehlerSchluessel(form.controls.lastName) | translate }}</mat-error>
          </mat-form-field>

          <mat-form-field appearance="fill" class="profil-bearbeiten__feld profil-bearbeiten__feld--voll">
            <mat-label>{{ 'profilBearbeiten.stammdaten.email' | translate }}</mat-label>
            <input matInput data-testid="profil-email" [value]="email()" [disabled]="true" />
            <mat-hint class="profil-bearbeiten__hinweis">
              {{ 'profilBearbeiten.stammdaten.emailHinweis' | translate }}
            </mat-hint>
          </mat-form-field>

          <mat-form-field appearance="fill" class="profil-bearbeiten__feld">
            <mat-label>{{ 'profilBearbeiten.stammdaten.sprache' | translate }}</mat-label>
            <mat-select formControlName="language" data-testid="profil-sprache">
              @for (sprache of sprachOptionen(); track sprache.code) {
                <mat-option [value]="sprache.code">{{ sprache.label }}</mat-option>
              }
            </mat-select>
            <mat-error>{{ fehlerSchluessel(form.controls.language) | translate }}</mat-error>
          </mat-form-field>

          <mat-form-field appearance="fill" class="profil-bearbeiten__feld">
            <mat-label>{{ 'profilBearbeiten.stammdaten.zeitzone' | translate }}</mat-label>
            <mat-select formControlName="timezone" data-testid="profil-zeitzone">
              @for (zone of zeitzonen(); track zone) {
                <mat-option [value]="zone">{{ zone }}</mat-option>
              }
            </mat-select>
            <mat-error>{{ fehlerSchluessel(form.controls.timezone) | translate }}</mat-error>
          </mat-form-field>
        </div>
      </article>

      <app-aktive-sitzungen />
    }
  </div>
</section>

<app-confirm-dialog
  [visible]="rueckfrage()"
  icon="edit_note"
  iconTon="akzent"
  confirmColor="primary"
  [title]="'common.unsavedChanges.title' | translate"
  [message]="'common.unsavedChanges.message' | translate"
  [confirmLabel]="'common.unsavedChanges.leave' | translate"
  [cancelLabel]="'common.unsavedChanges.stay' | translate"
  (confirmed)="rueckfrageBeantworten(true)"
  (cancelled)="rueckfrageBeantworten(false)"
/>
